'use client';

import { useSectionVisibility } from '~/lib/contexts/section-visibility-context';
import type { ExtractionStats } from '~/lib/feature-items';

import { HomeAboutSection } from './home-about-section';
import { HomeFeaturesCarousel } from './home-features-carousel';
import { HomePricingSection } from './home-pricing-section';
import { ScrollRevealBelow } from './scroll-reveal-below';

interface HomeBottomSectionsProps {
  extractionStats: ExtractionStats;
  lastSyncAt?: string | null;
}

export function HomeBottomSections({
  extractionStats,
  lastSyncAt,
}: HomeBottomSectionsProps) {
  const { main_pricing, main_about } = useSectionVisibility();

  return (
    <ScrollRevealBelow className="pb-20">
      <div className="space-y-12">
        {main_pricing && <HomePricingSection />}
        <HomeFeaturesCarousel
          extractionStats={extractionStats}
          lastSyncAt={lastSyncAt}
        />
        {main_about && <HomeAboutSection />}
      </div>
    </ScrollRevealBelow>
  );
}
